const apiConsts = {
  search: 'http://wixupdates.wixanswers.com/api/v1/articles/search/admin',
  findLabels: 'http://wixupdates.wixanswers.com/api/v1/labels',
  findArticleById: 'http://wixupdates.wixanswers.com/api/v1/articles/',
  socialBasePath: '//www.wix.com/release/notes'
};

module.exports = apiConsts;



// WEBPACK FOOTER //
// ./libs/api-consts.js